import styled from "@emotion/styled";
import {
  fontWeight,
  fontSize,
  breakpointValues,
  colorPrimitives,
} from "@atlas-int/tokens";
export const PageSection = styled.div`
  margin: 5vh 0 5vh;
  display: flex;
  min-width: 250px;
  grid-column: 2;
`;

/** Lighter H2 variant for landing page section headers */
export const H2 = styled.h2`
  font-weight: ${fontWeight.light};
  font-size: ${fontSize["2xl"]};
  color: ${colorPrimitives.landingMuted};
`;

export const breakpointSmall = breakpointValues.xs;

export const ArrowIcon = () => {
  return (
    <svg viewBox="0 0 16 16">
      <polygon points="7.2,0 7.2,2.5 11.7,2.5 0,14.2 1.8,16 13.5,4.3 13.5,8.8 16,8.8 16,2.5 16,1.8 16,0 "></polygon>
    </svg>
  );
};
